/**
 * H2C Backend
 * An ASP.NET Core Web API for managing H2C User 
 *
 * The version of the OpenAPI document: V40:2026_08_27_13_13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TGetFacilty02DTO } from './tGetFacilty02DTO';
import { TGetCompanyInfo1DTO } from './tGetCompanyInfo1DTO';


export interface TNewRegistrationDTO { 
    new_facility_list?: Array<TGetFacilty02DTO> | null;
    readonly new_company_list?: Array<TGetCompanyInfo1DTO> | null;
}

